export default function Gauge({
  label,
  value,
  min = 0,
  max = 1,
  isDarkMode = false
}: {
  label: string;
  value: number;
  min?: number;
  max?: number;
  isDarkMode?: boolean;
}) {
  const pct = Math.max(0, Math.min(100, ((value - min) / (max - min)) * 100));

  return (
    <div className="space-y-1">
      <div className="flex justify-between text-sm">
        <span className={isDarkMode ? 'text-white' : 'text-gray-900'}>{label}</span>
        <span className={isDarkMode ? 'text-white font-semibold' : 'text-gray-900'}>{value.toFixed(0)}%</span>
      </div>
      <div className={`h-2 rounded ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>
        <div className={`h-2 rounded transition-all ${isDarkMode ? 'bg-green-500' : 'bg-black'}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
